import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Event } from './_types';

export const normalizeEvent = (event: any): Event => {
  return camelcaseKeys(event, { deep: true }) as Event;
};
